import { UserRole } from '@shared/utils/base-auth';
import { RouteAccessRoles } from '../models/models';
import { AppRoutes } from '@shared/utils/navigation';

export const RouteAccessRuleSet: RouteAccessRoles[] = [
  new RouteAccessRoles(`/${AppRoutes.Dashboard}`, [UserRole.Supervisor, UserRole.Commander]),
  new RouteAccessRoles(`/${AppRoutes.Users}`, [UserRole.HRAdmin]),
  new RouteAccessRoles(`/${AppRoutes.Customers}`, [UserRole.HRAdmin]),
  new RouteAccessRoles(`/${AppRoutes.Files}`, [UserRole.User, UserRole.Supervisor, UserRole.Commander, UserRole.Prosecutor]),
  new RouteAccessRoles(`/${AppRoutes.Videos}`, [UserRole.User, UserRole.Supervisor, UserRole.Commander, UserRole.Prosecutor]),
  new RouteAccessRoles(`/${AppRoutes.Shared}`, [UserRole.User, UserRole.Supervisor, UserRole.Commander, UserRole.Prosecutor]),
  new RouteAccessRoles(`/${AppRoutes.Folders}`, [UserRole.User, UserRole.Supervisor, UserRole.Commander, UserRole.Prosecutor]),
];
